<template>
  <div class="checkin__last-call--list" v-if="hdAvailableTo || mediaAvailableTo">
    <InfoMediaAvailableList :available-to="mediaAvailableTo" v-if="mediaAvailableTo"/>
    <InfoHdAvailableList :hd-available-to="hdAvailableTo" v-else-if="hdAvailableTo && showOldMessages"/>
    <InfoSdHdAvailableList :hd-available-to="hdAvailableTo" v-else-if="hdAvailableTo && !showOldMessages"/>
  </div>
</template>


<script>
import InfoHdAvailableList from "@/domain/checkin/components/mediaInfo/InfoHdAvailableList.vue";
import InfoMediaAvailableList from "@/domain/checkin/components/mediaInfo/InfoMediaAvailableList.vue";
import InfoSdHdAvailableList from "@/domain/checkin/components/mediaInfo/InfoSdHdAvailableList.vue";

export default {
  name: "InfosMediaList",
  components: {
    InfoSdHdAvailableList,
    InfoMediaAvailableList,
    InfoHdAvailableList},
  props: {
    checkin: {
      type: Object,
      required: true
    }
  },
  computed: {
    hdAvailableTo() {
      return this.checkin.pica_service.hd_available_to
    },
    mediaAvailableTo() {
      return this.checkin.media_available_to
    },
    showOldMessages() {
      return new Date(this.hdAvailableTo).toDateString() <= new Date('2024-05-26').toDateString()
    },
  },

}
</script>

<style scoped>

</style>